import type { ServiceTopology, EditorModel } from 'types/core';
import { scriptLocation } from './utils';

const { isOpen } = require('@wix/santa-main-r/lib/lib/common/experiment');
const joinURL = require('@wix/santa-main-r/lib/lib/common/joinURL');

const DEFAULT_THEME = 'santa-editor-design-panel';
const MAIN_VERSION = '3.59.0';
const LATEST_VERSION = '3.85.0';
const SCALE_PROPORTIONALLY_VERSION =
  'd7f871a3dbf7c7564d69393d0a8d76c6b6f1d4652c9862ac127b0220';
const BASE_URL = 'https://static.parastorage.com/services/stylable-panel';
const FILE_PATH = 'dist/stylable-panel';

const LATEST_VERSION_EXPERIMENT = 'se_stylablePanelEE';
const SCALE_PROPORTIONALLY_EXPERIMENT = 'se_stylablePanelSPSupport';
const MIGRATE_STYLABLE_THEMES_EXPERIMENT = 'se_stylableThemeMigration';

export const stConfig = {
  experimentName: LATEST_VERSION_EXPERIMENT,
  getStylablePanelPath: (
    serviceTopology: ServiceTopology | undefined,
    editorModel: EditorModel,
  ) => {
    if (isOpen(SCALE_PROPORTIONALLY_EXPERIMENT, { editorModel })) {
      return joinURL(`${BASE_URL}/${SCALE_PROPORTIONALLY_VERSION}`, FILE_PATH);
    } else if (isOpen(LATEST_VERSION_EXPERIMENT, { editorModel })) {
      return joinURL(
        scriptLocation(
          serviceTopology,
          'stylable-panel',
          `${BASE_URL}/${LATEST_VERSION}`,
        ),
        FILE_PATH,
      );
    }
    return joinURL(`${BASE_URL}/${MAIN_VERSION}`, FILE_PATH);
  },
  getThemePath: (themeName = DEFAULT_THEME, editorModel: EditorModel) =>
    isOpen(MIGRATE_STYLABLE_THEMES_EXPERIMENT, { editorModel })
      ? `https://static.parastorage.com/unpkg/@wix/stylable-editor-themes@3.28.0/dist/${themeName}/${themeName}.concat.css`
      : `https://static.parastorage.com/unpkg/@wixc3/stylable-editor-themes@1.1.20/dist/${themeName}/${themeName}.concat.css`,
  modulePath: '',
};
